import React, { useEffect, useRef, useState } from "react";
import styles from "./Attendees.module.css";
import { SearchInput, TextComponent } from "../../../../components";
import { List, Skeleton } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { EventPlanningMiddleware } from "../../../../Store/Middlewares/EventPlanningMiddleware";

const StarIcon = () => {
  return (
    <svg
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles.svgIcon}
    >
      <path
        d="M23.7957 10.0167C23.7404 9.89005 23.6629 9.7743 23.567 9.67484L16.567 2.67484C16.4676 2.57892 16.3518 2.50149 16.2252 2.44617C16.1902 2.42984 16.1529 2.42051 16.1155 2.40767C16.0179 2.37446 15.9163 2.35444 15.8134 2.34817C15.7889 2.34584 15.7667 2.33301 15.7422 2.33301H7.57552C6.28869 2.33301 5.24219 3.37951 5.24219 4.66634V23.333C5.24219 24.6198 6.28869 25.6663 7.57552 25.6663H21.5755C22.8624 25.6663 23.9089 24.6198 23.9089 23.333V10.4997C23.9089 10.4752 23.896 10.453 23.8937 10.4273C23.888 10.3243 23.868 10.2226 23.8342 10.1252C23.8225 10.0878 23.812 10.0517 23.7957 10.0167ZM19.9259 9.33301H16.9089V6.31601L19.9259 9.33301ZM7.57552 23.333V4.66634H14.5755V10.4997C14.5755 10.8091 14.6984 11.1058 14.9172 11.3246C15.136 11.5434 15.4328 11.6663 15.7422 11.6663H21.5755L21.5779 23.333H7.57552Z"
        className={styles.svgIconPath}
      />
      <path
        d="M9.91406 13.9997H19.2474V16.333H9.91406V13.9997ZM9.91406 18.6663H19.2474V20.9997H9.91406V18.6663ZM9.91406 9.33301H12.2474V11.6663H9.91406V9.33301Z"
        className={styles.svgIconPath}
      />
    </svg>
  );
};
const dummydata = [
  {
    id: 1,

    name: "Frances Swann",
  },
  {
    id: 1,

    name: "Frances Swann",
  },
  {
    id: 1,

    name: "Frances Swann",
  },
];

const Attendees = () => {
  const Attendees = useSelector((state) => state.EventPlanningReducer.Attendee);

  const EventDetails = useSelector((state) => state.EventReducer.EventDetails);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const searchRef = useRef();

  useEffect(() => {
    dispatch(
      EventPlanningMiddleware.eventAttendees({
        id: EventDetails?.id,
        status: "confirmed",
      })
    )
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  }, []);

  const onSearch = (name) => {
    clearTimeout(searchRef.current);
    searchRef.current = setTimeout(() => {
      setLoading(true);
      dispatch(
        EventPlanningMiddleware.eventAttendees({
          id: EventDetails?.id,
          status: "confirmed",
          name,
        })
      )
        .then(() => {
          setLoading(false);
        })
        .catch(() => setLoading(false));
    }, 500);
  };

  const printDocument = () => {
    dispatch(EventPlanningMiddleware.generateGuestPdf(EventDetails?.id)).then(
      (response) => {
        const pdfUrl = `https://www.bestdayever.me/api/downloadFile?path=${response.attachment}`;

        const link = document.createElement("a");
        link.href = pdfUrl;
        // link.target = "_blank";
        link.download = "Event Timeline"; // specify the filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        // saveAs(response?.attachment, `${response.title}.pdf`);
      }
    );
  };

  return (
    <div className={styles.mainCont}>
      <div className={styles.header}>
        <div className={styles.searchDiv}>
          <SearchInput
            placeholder={"Search"}
            onChange={(e) => onSearch(e.target.value)}
          />
        </div>
        <div className={styles.pdfDiv} onClick={printDocument}>
          <StarIcon />
          <TextComponent text={"Export pdf"} textClass={styles.exportText} />
        </div>
      </div>
      <Skeleton loading={loading}>
        <List
          dataSource={Attendees?.length > 0 ? Attendees : []}
          className={styles.list}
          renderItem={(item, index) => {
            return (
              <div
                className={styles.listItem}
                key={index}
                onClick={() => {
                  navigate("/events/guestDetails/Attendees", {
                    state: {
                      headrTitle: "Attendees",
                      item: item,
                    },
                  });
                }}
              >
                <TextComponent text={item?.name} textClass={styles.listname} />
              </div>
            );
          }}
        />
      </Skeleton>
    </div>
  );
};

export default Attendees;
